import { useNavigate, useSearchParams } from 'react-router';
import { ListItemButton } from '@mui/material';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { useAppDispatch } from '@reduxStore';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { defaultFilterModel } from '../types';
import { setDispatchSnapshot } from '@/Infrastructure/applicationSlice';
import { useMemo } from 'react';
import { emptyRowSet } from '@components/DataGrid/types';
import useCurrentTerminal from '@/Hooks/useCurrentTerminal';

/**
 * View All Legs by JobId Action
 */
export default function ViewAllLegsAction() {
	const gridApiRef = useGridApiContext();
	const [searchParameters, setSearchParameters] = useSearchParams();
	const appDispatch = useAppDispatch();
	const navigate = useNavigate();
	const { number: terminalNumber } = useCurrentTerminal();
	const selectedRowIds = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);
	const isOnBoard = location.pathname.includes('/Board');

	const leg = useMemo(() => {
		const legId = selectedRowIds.keys().next().value;
		return legId ? gridApiRef.current.getRow<DispatchLeg>(legId) : undefined;
	}, [gridApiRef, selectedRowIds]);

	// This action requires exactly 1 row to be selected - if there is a csn parameter, already there, no need to show
	if (selectedRowIds.size !== 1 || searchParameters.get('csn') || !leg) {
		return <></>;
	}

	const handleBtnClick = () => {
		/** Snapshot the current Board we are on for routing back */
		appDispatch(setDispatchSnapshot(`${location.pathname}${location.search}`));

		const params = new URLSearchParams({
			job: leg.jobId.toString(),
			csn: leg.csnNo.toString().padStart(3, '0')
		});

		if (isOnBoard) {
			/** Reset the current filters on the board */
			gridApiRef.current.setRowSelectionModel(emptyRowSet);
			gridApiRef.current.setFilterModel(defaultFilterModel);

			setSearchParameters(params);
		} else {
			void navigate(`/${terminalNumber}/Board?${params.toString()}`);
		}
	};

	return <ListItemButton onClick={handleBtnClick}>View All Legs for this Container</ListItemButton>;
}
